// Static data and asset URLs used across the Landing page section components.
// Keeping these centralised means each section can be swapped/rearranged
// without re-importing image paths or arrays.

import {
  Buildings, Briefcase, Truck, Megaphone,
  Lightbulb, ChartLineUp, UsersThree, Compass,
} from "@phosphor-icons/react";

export const CVC_LOGO = "https://customer-assets.emergentagent.com/job_eaaeb4ba-efcb-4a70-85e7-8b14c154ace9/artifacts/uuciacvc_CVC%20flat.jpg";
export const SCALED_LOGO = "/scaled-logo-green.png";
export const HERO_BG = "https://images.pexels.com/photos/19963904/pexels-photo-19963904.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";
export const JONATHAN_PORTRAIT = "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/s6s9w0wr_JonathanHeadshot2022.png";
export const HANDSHAKE = "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/3e9atyaa_EDITED%20done.jpg";
export const EPIC_BANNER = "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/44tqkuh8_epic%20banner%20PNG2.jpg";
export const CLIENT_RED_SHIRT = "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/vxpiy9xd_Photo%20Feb%2021%202020%2C%2011%2042%2031%20AM.jpg";
export const CALI_SPECIALIST = "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/apitycsp_edited%20cali2.jpg";
export const JONATHAN_SIGNUP_CARD_PHOTO = "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/uj31dsqd_IMG_1678.JPG";

// On-site / in-the-wild candid photos of Jonathan with Cache Valley clients
export const ON_SITE_PHOTOS = [
  { url: "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/fi792g2w_Photo%20Mar%2001%202021%2C%202%2051%2025%20PM.jpg", alt: "Jonathan at a Cache Valley cabinet shop, walking the floor with a client team." },
  { url: "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/edpikn9q_Photo%20Mar%2011%202021%2C%2012%2028%2013%20PM.jpg", alt: "Jonathan and an owner above the production floor at a Cache Valley CNC machine shop." },
  { url: "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/1n40lrzm_Photo%20Jun%2017%202020%2C%2010%2045%2057%20AM.jpg", alt: "Jonathan at a client's front-office in Logan, UT." },
  { url: "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/aj0q2m6z_57601349592__00FE6C23-2EF8-4F70-B0F9-AE946E2E9143.JPG", alt: "Jonathan with a Cache Valley client owner during a working session." },
  { url: "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/l4nnbdrb_Photo%20Jan%2027%202021%2C%209%2058%2043%20AM.jpg", alt: "Jonathan on-site as a Cache Valley client builds out their new shop." },
];

export const DOMAINS = [
  { name: "Administration", icon: Buildings, desc: "Books, ops cadence, vendors, systems — the back-of-house engine." },
  { name: "Production", icon: Briefcase, desc: "Preparing your product or service — and automating wherever it pays." },
  { name: "Distribution", icon: Truck, desc: "Sales pipeline, delivery, and install — getting offer to customer." },
  { name: "Marketing", icon: Megaphone, desc: "Steady demand, brand truth, and the message that lands." },
  { name: "Innovation", icon: Lightbulb, desc: "What's next — offers, pricing, and quiet R&D." },
  { name: "Finance", icon: ChartLineUp, desc: "Margin, cash, taxes — the numbers that keep the doors open." },
  { name: "Talent", icon: UsersThree, desc: "Recruit, train, retain, manage. The arts of hiring and firing." },
  { name: "Leadership", icon: Compass, desc: "Frontline supervision, middle-management accountability, executive planning." },
];

export const QUALS = [
  "You've hired employees before — ideally 5 or more on your team today",
  "Your business is already at (or near) 10%+ net profit margin",
  "Your customer base is plentiful and your offering is clearly in demand",
  "Our consulting fee fits comfortably in your monthly budget",
  "You're willing to follow scaling instructions and apply advice diligently",
];

// Fade-ticker copy for the journey cards — pains on the left (Today), outcomes on the right (After)
export const TODAY_PAINS = [
  "You're still the bottleneck.",
  "Every fire still lands on your desk.",
  "Growth feels overwhelming, not manageable.",
  "The team can't win without you in the room.",
  "Trading your hours for revenue — not building value.",
  "It's a job, not an asset.",
  "Years of figuring-it-out — still ahead.",
  "Stronger talent and partnerships out of reach.",
];

export const AFTER_OUTCOMES = [
  "Stop being the bottleneck.",
  "Build an asset — not a job.",
  "Room for bigger opportunities.",
  "Less time putting out fires.",
  "Growth feels manageable.",
  "Stronger talent. Stronger customers. Stronger partnerships.",
  "A company that thrives without you in the room.",
  "Freedom to focus on what matters most.",
  "Years of trial-and-error — skipped.",
  "Decisions made with greater confidence.",
  "Momentum where frustration used to live.",
  "An exit story worth telling.",
];
